var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#support_svg__b)",
    d: "M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#support_svg__c)",
    d: "M47.632 41.688q-.14-.419-1.77-1.233a54 54 0 0 0-1.255-.698q-.816-.443-1.478-.815a49 49 0 0 1-1.246-.721 31 31 0 0 0-.582-.408 6.5 6.5 0 0 0-.826-.5 1.5 1.5 0 0 0-.663-.163q-.465 0-1.164.663t-1.28 1.444q-.58.78-1.233 1.443-.651.663-1.07.663-.21-.001-.524-.116a5 5 0 0 1-.478-.198 9 9 0 0 1-.558-.326 14 14 0 0 0-.442-.268q-3.189-1.77-5.47-4.05t-4.049-5.469a13 13 0 0 0-.268-.442 9 9 0 0 1-.326-.559 5 5 0 0 1-.197-.477 1.6 1.6 0 0 1-.117-.523q0-.42.664-1.071a14 14 0 0 1 1.443-1.233q.78-.582 1.443-1.28t.663-1.163a1.5 1.5 0 0 0-.163-.664 6.5 6.5 0 0 0-.5-.826q-.338-.489-.408-.582a52 52 0 0 1-.721-1.245q-.373-.663-.815-1.478a55 55 0 0 0-.698-1.257q-.815-1.628-1.233-1.768-.163-.07-.489-.07-.629 0-1.64.233-1.014.233-1.595.488-1.164.49-2.467 2.84-1.187 2.186-1.187 4.328a9 9 0 0 0 .082 1.222q.081.593.29 1.338.21.745.338 1.105t.477 1.292q.349.93.419 1.14.815 2.282 1.931 4.073 1.84 2.979 5.015 6.157 3.177 3.177 6.157 5.015 1.791 1.116 4.073 1.932.21.07 1.14.419t1.291.477 1.105.338q.746.21 1.339.291.594.082 1.222.082 2.14 0 4.329-1.187 2.35-1.305 2.838-2.468.257-.581.49-1.594t.232-1.64q0-.327-.07-.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.923 34.048a1.365 1.365 0 0 1-1.366-1.365c0-5.646-4.593-10.24-10.24-10.24a1.365 1.365 0 1 1 0-2.73c7.152 0 12.971 5.818 12.971 12.97 0 .754-.611 1.365-1.365 1.365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.144 34.048a1.365 1.365 0 0 1-1.365-1.365 5.47 5.47 0 0 0-5.462-5.462 1.365 1.365 0 1 1 0-2.73c4.517 0 8.192 3.675 8.192 8.192 0 .754-.61 1.365-1.365 1.365M47.701 34.048a1.365 1.365 0 0 1-1.365-1.365c0-8.281-6.737-15.019-15.018-15.019a1.365 1.365 0 1 1 0-2.73c9.787 0 17.749 7.962 17.749 17.749 0 .754-.612 1.365-1.366 1.365"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_svg__b",
    x1: 9.373,
    x2: 54.627,
    y1: 54.627,
    y2: 9.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A996FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_svg__c",
    x1: 23.486,
    x2: 35.007,
    y1: 40.514,
    y2: 28.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3CAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export default SvgSupport;